export const NUMBER_NOTIFICATIONS_UNREAD = `
  query getNumberNotificationsUnRead {
    getNumberNotificationsUnRead
  }
`;

export const NOTIFICATIONS_PAGINATION = `
  query notificationsPagination($input: NotificationPaginationInput) {
    notificationsPagination(input: $input) {
      docs {
        id
        commentId
        commentType
        createdAt
        deepLink
        gameName
        message
        previousRank
        rank
        rankingId
        reportId
        senderId
        status
        thumbnail
        top
        type
        videoId
        sender {
          id
          avatar
          username
        }
      }
      hasNextPage
      totalDocs
    }
  }
`;

export const NOTIFICATIONS_UNREAD_COUNT_SUBSCRIPTION = `
  subscription notificationsUnreadCount {
    notificationsUnreadCount
  }
`;

// Admin: the notifications sent, with their receiver (opens his drawer) and their push.
export const NOTIFICATIONS_ADMIN_PAGINATION = `
  query notificationsAdminPagination($input: NotificationAdminPaginationInput!) {
    notificationsAdminPagination(input: $input) {
      docs {
        id
        commentType
        createdAt
        fcmBody
        fcmErrorCode
        fcmStatus
        fcmTitle
        gameName
        message
        rank
        receiverId
        reportId
        senderId
        status
        thumbnail
        type
        videoId
        receiver {
          id
          avatar
          bio
          connectedAt
          connectedWith
          createdAt
          dateOfBirth
          deletedAt
          email
          fcmPermissionStatus
          language
          timezone
          username
          versionApple
          versionAndroid
        }
        sender {
          id
          avatar
          username
        }
      }
      totalDocs
    }
  }
`;
